import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineYoutube,
  AiFillInstagram,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn, FaCode, FaLaptopCode, FaMobileAlt } from "react-icons/fa";
import logo from "../Assets/photo_2025-06-14_12-10-48.jpg";

function FatFooter() {
  const year = new Date().getFullYear();

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(script);

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          autoDisplay: true,
          layout: window.google.translate.TranslateElement.InlineLayout.HORIZONTAL,
        },
        "google_translate_element"
      );
    };
  }, []);

  return (
    <footer
      style={{
        background: "linear-gradient(135deg, #0d0d1a, #1a1a2e)",
        fontSize: "0.9rem",
        color: "#fff",
      }}
    >
      <Container className="py-5">
        {/* --- Top Section (Logo + Socials) --- */}
        <Row className="mb-5 text-center">
          <Col>
            <img
              src={logo}
              alt="brand"
              width={60}
              height={60}
              style={{ borderRadius: "50%", marginBottom: "10px" }}
            />
            <p className="mb-2">
              Feel free to <span className="purple">connect</span> with me
            </p>
            <ul
              className="list-inline d-flex justify-content-center gap-3"
              style={{ marginTop: "15px" }}
            >
              <li>
                <a
                  href="https://github.com/Vazgen47"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub size={25} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@Vazgen47"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineYoutube size={25} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/vazgen-mkheyan-765962376/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn size={25} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/themkheyan?igsh=MTE5cTlwOXY0dHFxYw%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram size={25} />
                </a>
              </li>
              <li>
                <a
                  href="mailto:programmer.2010.06@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineMail size={25} />
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        {/* --- Services Section ---
        <Row className="text-center mb-5">
          <Col>
            <h4 className="mb-4" style={{ color: "#00ff88", letterSpacing: "1px" }}>
              My Services
            </h4>
          </Col>
        </Row>

        <Row className="text-center g-4 justify-content-center">
          <Col xs={12} md={4}>
            <div className="p-4 rounded-4 bg-white/10 hover:bg-white/20 transition-all duration-500 shadow">
              <FaCode size={35} className="text-green-400 mb-3" />
              <h5 className="fw-bold text-white mb-2">Full Stack Development</h5>
              <p style={{ color: "#bfbfbf" }}>
                Modern and responsive UI with React, TailwindCSS and Bootstrap.
              </p>
            </div>
          </Col> */}
          {/* <Col xs={12} md={4}>
            <div className="p-4 rounded-4 bg-white/10 hover:bg-white/20 transition-all duration-500 shadow">
              <FaLaptopCode size={35} className="text-green-400 mb-3" />
              <h5 className="fw-bold text-white mb-2">Web Applications</h5>
              <p style={{ color: "#bfbfbf" }}>
                Building dynamic web apps with APIs, user auth and backend logic.
              </p>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <div className="p-4 rounded-4 bg-white/10 hover:bg-white/20 transition-all duration-500 shadow">
              <FaMobileAlt size={35} className="text-green-400 mb-3" />
              <h5 className="fw-bold text-white mb-2">Responsive Design</h5>
              <p style={{ color: "#bfbfbf" }}>
                Fully optimized for all screen sizes and mobile devices.
              </p>
            </div>
          </Col>
        </Row> */}

       
        {/* --- Footer Bottom --- */}
        <Row
          className="pt-4 mt-4"
          style={{
            borderTop: "1px solid #34495e",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Col>
            <p style={{ color: "#aaa", marginBottom: "0" }}>
              &copy; {year} <strong>Vazgen Mkheyan</strong>. All Rights Reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default FatFooter;
